import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import GameSetupShell, { LevelStart, RunHeader, TileGrid, useGameStats } from '../../components/Games2/GameSetupShell';

const LEVELS = [
  { id: 1, name: 'Level 1', description: 'Practice Mode', color: 'green', totalTasks: 20, timeLimit: 0, details: ['20 tasks', 'No time limit', 'Practice mode'] },
  { id: 2, name: 'Level 2', description: 'Real Test Mode', color: 'rose', totalTasks: 20, timeLimit: 20, details: ['20 tasks', '20 minute time limit', 'Real exam conditions'] },
];
const LEVEL_COLORS = { 1: 'green', 2: 'rose' };

const score = (r) => parseFloat(r.final_score) || 0;
const pct = (v) => `${v == null ? 0 : Math.round(parseFloat(v))}%`;

const PPTSetup2 = () => {
  const { subjectId } = useParams();
  const navigate = useNavigate();
  const game = useGameStats('PPT', subjectId);
  const { stats } = game;
  const [level, setLevel] = useState(2);

  const start = () => {
    const l = LEVELS.find((x) => x.id === level);
    navigate(`/games/ppt/${subjectId}/play`, { state: { level, totalTasks: l.totalTasks, timeLimit: l.timeLimit, subject: stats?.subject } });
  };

  return (
    <GameSetupShell
      code="PPT"
      name="Paper Folding Test"
      description="Spatial visualisation assessment game"
      game={game}
      heroStats={[
        { label: 'Runs', value: stats?.total_runs || 0 },
        { label: 'Best', value: pct(stats?.best_score) },
        { label: 'Average', value: pct(stats?.average_score) },
      ]}
      picker={<LevelStart levels={LEVELS} value={level} onChange={setLevel} onStart={start} />}
      runs={stats?.history || []}
      filterLevels={[1, 2]}
      levelColors={LEVEL_COLORS}
      chart={{ series: [{ label: 'Score', color: '#10B981', value: score, main: true }], max: 100, suffix: '%' }}
      renderRun={(run) => (
        <div className="space-y-4">
          <RunHeader run={run} level={run.level || 1} levelColor={LEVEL_COLORS[run.level || 1]} score={`${score(run).toFixed(1)}%`} scoreLabel={`${run.correct_count}/${run.total_tasks} correct`} />
          {(run.tasks_data || []).length > 0 && (
            <TileGrid title="Task results" items={run.tasks_data.map((t, i) => ({ label: `T${i + 1}`, value: t.is_correct ? '✓' : '✗', tone: t.is_correct ? 'good' : 'bad' }))} />
          )}
        </div>
      )}
    />
  );
};

export default PPTSetup2;
